import { useState, useEffect } from 'react';

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed bottom-8 right-8 z-50 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      {/* Tooltip / label */}
      <div
        className={`transition-all duration-300 ${
          expanded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        <div className="bg-white border border-brand-border rounded-xl px-4 py-3 max-w-[220px] shadow-sm">
          <p className="font-inter text-xs font-semibold text-brand-dark mb-0.5">
            Fale com a advogada
          </p>
          <p className="font-inter text-xs text-brand-muted leading-snug">
            Resposta rápida pelo WhatsApp
          </p>
        </div>
      </div>

      {/* Main button */}
      <div className="relative">
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-15" style={{ animationDelay: '0.4s' }} />

        <a
          href="https://api.whatsapp.com/send?phone=5551996057679&text=Ol%C3%A1,%20vim%20do%20seu%20site%20e%20gostaria%20de%20falar%20com%20um%20advogado."
          target="_blank"
          rel="noopener noreferrer"
          onMouseEnter={() => setExpanded(true)}
          onMouseLeave={() => setExpanded(false)}
          className="relative cursor-pointer w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#20ba5a] rounded-full transition-transform duration-200 hover:scale-110"
          aria-label="Falar pelo WhatsApp"
        >
          <i className="ri-whatsapp-line text-white text-2xl" />
        </a>
      </div>
    </div>
  );
}
